import styled from '@emotion/styled'

import { mediaMax } from '@/styles/mixins'

export const Container = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5rem;

  ${mediaMax.md} {
    margin-right: 0;
  }
`

export const Image = styled.img`
  height: 25px;
  width: auto;
  display: block;
  object-fit: contain;

  ${mediaMax.xs} {
    height: 1.1rem;
  }
`

export const Label = styled.span`
  margin-left: 1.5rem;
  text-transform: capitalize;
  font-family: ${({ theme }) => theme.fonts.serif};
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.brown};

  ${mediaMax.xs} {
    font-size: 1.4rem;
    margin-left: .75rem;
  }

`
